import { gql } from '@apollo/client'

// Structural subset of the fragment below, so callers pass the generated
// fragment type while tests pass literals (avoids depending on codegen).
export interface CompleteSignupNudgeViewer {
  pid?: number | string | null
  cpf?: string | null
  isCpfValid?: boolean | null
  birthDate?: number | null
  hasPaidPlan?: boolean | null
  mainPhone?: { phone?: string | null } | null
}

// Keep pure (no hooks/IO) — also runs server-side in the entity GSSP.
export function isCompleteSignupNudgeEligible(
  viewer: CompleteSignupNudgeViewer | null | undefined
): boolean {
  if (!viewer?.pid) return false
  if (viewer.hasPaidPlan) return false
  if (viewer.isCpfValid) return false

  if (!viewer.cpf) return true
  return isMissingBirthDate(viewer.birthDate)
}

function isMissingBirthDate(birthDate: number | null | undefined): boolean {
  return birthDate == null || Number.isNaN(Number(birthDate))
}

export function shouldSkipPhoneStep(
  viewer: Pick<CompleteSignupNudgeViewer, 'mainPhone'> | null | undefined
): boolean {
  // Key on the number, not phoneId: phoneId stays null for an unvalidated phone (and the nudge
  // never validates the phone), so a filled-but-unvalidated number must still skip the step.
  // Matches how the signup phone step decides (mainPhone { phone }).
  return !!viewer?.mainPhone?.phone
}

export const completeSignupNudgeViewerFragment = gql`
  fragment CompleteSignupNudgeViewer on Profile {
    pid
    cpf
    isCpfValid
    birthDate
    hasPaidPlan
    mainPhone {
      phone
    }
  }
`
